import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import { useNavigate } from "react-router-dom";
import { FaRegAddressCard } from "react-icons/fa";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FaPhone } from "react-icons/fa6";
import { handleTopScroll } from "../../../../common/function/ScroolTop";

const ContactUs = () => {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: "getContact",
    queryFn: () =>
      axios.get(`${BASEURL}contacts`).then((res) => {
        return res?.data;
      }),
  });

  const handleNavigate=()=>{
    navigate("/allbrocedure")
    handleTopScroll()
  }
  return (
    <div className="contactus-box">
      <h3 className="footer-heding">Contact us</h3>
      <div className="flex my-2">
        <FaRegAddressCard className="w-10 h-10 mr-2 " />
        <p>{data?.address}</p>
      </div>
      {data?.email?.map((v, i) => {
        return (
          <p key={i} className="hover:text-white flex items-center ">
            <HiOutlineMailOpen className="w-6 h-6 mr-1  " />
            <a href={`mailto:${v}`}>{v}</a>
          </p>
        );
      })}
      {data?.phone?.map((v, i) => {
        return (
          <p key={i} className="hover:text-white flex items-center ">
            <FaPhone className="w-5 h-5 mr-2 " />
            <a href={`tel:${v}`}>{v}</a>
          </p>
        );
      })}

      <button onClick={() => handleNavigate()}>Get Brochure</button>
    </div>
  );
};

export default ContactUs;
